export default "__VITE_ASSET__edd9f311__"